import React, { useState, useMemo } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

const CustomDropdown = ({ rowData, viewclick, returnLink, retutrnClick, editLink, cancleClick, projecteditLink, bookingLink }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const { slug } = useParams();

    const toggleDropdown = () => setIsOpen(!isOpen);

    const masterdata = useSelector((state) => state.globalslice.masterdata || []);
    const tabs_data = useMemo(() => (
        masterdata
            .filter(ele => ele.list_type === 'order_status')
            .map((item, index) => ({
                id: item.list_value,
                title: item.list_lable,
                list_key: item.list_key,
            }))
    ), [masterdata]);

    // Find current and next status
    const currentIndex = tabs_data.findIndex(tab => tab.id === rowData.order_statusid);
    const nextTab = currentIndex !== -1 ? tabs_data[currentIndex + 1] : null;

    return (
        <Dropdown isOpen={isOpen} toggle={toggleDropdown} className="ms-2">
            <DropdownToggle tag="button" type="button" className="btn btn-light btn-sm bg-transparent border-0 text-primary">
                <i className="ri-more-2-fill" />
            </DropdownToggle>

            <DropdownMenu className="dropdown-menu-end dropdown-box">
             
                    <>
                        {projecteditLink && (
                            <DropdownItem onClick={() => navigate(projecteditLink)}>
                                Edit Project
                            </DropdownItem>
                        )}
                         {bookingLink && (
                            <DropdownItem onClick={() => navigate(bookingLink)}>
                                Book Unit
                            </DropdownItem>
                        )}

                    </>
               
                    <>
                        {editLink && (
                            <DropdownItem onClick={() => navigate(editLink)}>
                                Edit Order
                            </DropdownItem>
                        )}
                        {/* <DropdownItem onClick={() => viewclick(rowData.orderid)}>
                            View Order
                        </DropdownItem> */}
                        {
                            retutrnClick &&
                            <DropdownItem onClick={() => navigate(returnLink)}>
                                Return
                            </DropdownItem>
                        }

                        {
                            cancleClick &&
                            <DropdownItem onClick={() => cancleClick(rowData.orderid)}>
                                Cancel
                            </DropdownItem>
                        }
                        {/* {nextTab && (
                            <DropdownItem onClick={() => nextprocessClick(rowData.orderid, nextTab.id)}>
                                {nextTab.title}
                            </DropdownItem>
                        )} */}
                    </>
                
            </DropdownMenu>
        </Dropdown>
    );
};

export default CustomDropdown;
